import moment from 'moment';
import { useContext, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
//import { canEditProfile, getDomainValueForCode, isEmpty } from '../../../../library/Core/SmartFunctions';
import DebugBarControl from '../../../../library/SimpleControls/DebugBarControl';
import SessionContext from '../../../../library/Core/SessionContext';
import logger from '../../../../library/Core/logger';
import { axiosClient } from '../../../../library/Service/axiosClient';
import { canEditProfile, getDomainValueForCode, getFlexColDomainValueForCode, isEmpty, isSchoolAdmin, isSuperAdmin } from '../../../../library/Core/SmartFunctions';

const Counselling = () => {
    const { state, dispatch } = useContext(SmartContext);
    const model = state.internal.model;
    const { id, pageName } = useParams();
    const navigate = useNavigate();
    const { sessionState }: any = useContext(SessionContext);
    const data = state?.data?.basPsychometricInfo ?? [];
    const userInstitutes = state?.data?.userInstitutes;
    const [isAchievementsCollapsed, setAchievementsIsCollapsed] = useState(true); 
    const [isBooksCollapsed, setBooksIsCollapsed] = useState(true); 
    const [isActivitiesCollapsed, setActivitiesIsCollapsed] = useState(true); 

    if ( sessionState?.userTypeCode === 'STUDENT' && sessionState?.profileStatusCode === 'PREFERENCES_INCOMPLETE' ) {
        window.location.href = `/alumni/${sessionState?.id}/student-preference`;
        return null; // Redirection is initiated, so no need to render further
    }

    const instituteNames = userInstitutes
        .map((institute: any) => {
            return getDomainValueForCode(institute.instituteId, 'INSTITUTE_DOMAIN', state) ?? '';
        })
        .join(', ');

    return (
        // <div className="tab-pane fade" id="pills-extraCurriculars" role="tabpanel" aria-labelledby="pills-extraCurriculars-tab">
        <div>
            <div className="counselling-lists">
                <div className="tab-white-block mb-2 p-0 overflow-hidden border">
                    
                    <div className="d-flex flex-wrap flex-column flex-md-row">
                        <div className="nav flex-row flex-md-column nav-pills custom-sub-tab ps-3 py-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <Link className="nav-link active" to={`/alumni/${id}/profile/counselling`}>Psychometric Tests </Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/sessions`}>Sessions</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/counselling-logs`}>Counselling Logs</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/communication-logs`} >Communication Logs</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/counsellor-notes`} >Counsellor Notes</Link>                                           
                        </div>
                        <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 width-cal-191" id="v-pills-tabContent">
                            
                        <div className='row g-4'>
                        

                        {data.map((item: any, index: number) => {
                            // Default values
                            console.log(item, 'item each record 58 latest change')
                            console.log('59 line number changes')
                            let status = 'Not Assigned';
                            let statusClass = 'bg-gray-E6E6E6 text-dark';
                            let testDateLabel = 'Test Started on -';
                            let testDateValue = 'NA';
                            let testResultLabel = 'Test Result -';
                            let testResultValue = 'NA';
                            let showMail = false;
                            let showCopy = false;
                            let showReport = false;

                            const isMapped = item.is_mapped === 1;
                            console.log('start_date:', item.start_date);
                            console.log('parsed:', new Date(item.start_date).toString());
                            console.log('isValid:', !isNaN(new Date(item.start_date).getTime()));

                            const formatDate = (date: string | number | Date): string => {
                                const d = new Date(date);
                                const day = String(d.getDate()).padStart(2, '0');
                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                const year = d.getFullYear();
                                return `${day}/${month}/${year}`;
                              };
                              
                            
                            if (item.end_date && !isNaN(new Date(item.end_date).getTime())) {
                                const endDate = new Date(item.end_date);
                                status = 'Completed';
                                statusClass = 'bg-green text-white';
                                testDateLabel = 'Test Completed on -';
                                testDateValue = formatDate(endDate);
                                testResultValue = 'Completed'; // Replace with actual result
                                showReport = true;
                              } else if (!isMapped) {
                                status = 'Not Assigned';
                                statusClass = 'bg-gray-E6E6E6 text-dark';
                                testDateLabel = '';
                                testDateValue = '';
                                testResultLabel = '';
                                testResultValue = '';
                              } else if  (item.start_date && !isNaN(new Date(item.start_date).getTime())) {
                                const startDate = new Date(item.start_date);
                                status = 'Started';
                                statusClass = 'bg-green text-white';
                                testDateLabel = 'Test Started on -';
                                testDateValue = formatDate(startDate);
                                testResultValue = 'Yet to come';
                                showMail = true;
                                showCopy = true;
                              } else if (item.test_status === null && isMapped) {
                                status = 'Not Taken';
                                statusClass = 'bg-darker-blue text-white';
                                showMail = true;
                                showCopy = true;
                              }
                              

                            // Build dynamic link
                            const flexCol = getFlexColDomainValueForCode(item.institute_id, 'INSTITUTE_DOMAIN', state);
                            const whitelabel_url = !isEmpty(flexCol) ? JSON.parse(flexCol).whitelabel_url : '';
                            const baseUrl = whitelabel_url || `${process.env.REACT_APP_APP_BASE_URL}/`;
                            const userHash = item.user_hash || ''; // if available
                            // const profileLink = `${baseUrl}sso/${userHash}/${btoa('profile')}`;


                            let encodedPath = '';

                            if (item.test_code === 101) {
                                encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvTGVhcm5pbmdzdHlsZXRlc3Q=';
                            } else if (item.test_code === 100) {
                                encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvTXVsdGlwbGVJbnRlbGxpZ2VuY2VUZXN0';
                            } else if (item.test_code === 104) {
                                encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvUGVyc29uYWxpdHlUZXN0';
                            } else if (item.test_code === 115) {
                                encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvU3RyZWFtU2VsZWN0b3JUZXN0';
                            } else if (item.test_code === 114) {
                                encodedPath = 'cHN5Y2hvbWV0cmljX3Rlc3QvY2FyZWVyR3VpZGUvSWRlYWxjYXJlZXJ0ZXN0';
                            } else {
                                encodedPath = btoa('profile');
                            }

                            const profileLink = `${baseUrl}sso/${userHash}/${encodedPath}`;


                            const handleCopy = () => {
                                navigator.clipboard.writeText(profileLink);
                                alert('Link copied to clipboard!');
                            };


                            const handleSendMail = async (item: any) => {
                                try {
                                    const response = await axiosClient().post(
                                        `${process.env.REACT_APP_BAS_API}/sendmail/psychometric-mail`,
                                        item
                                    );
                                    console.log(response.data, 'mail response data');
                                
                                    if (response.data.success) {
                                        alert('Mail sent successfully!');
                                    } else {
                                        alert('Failed to send mail.');
                                    }
                                } catch (error) {
                                    console.error('Mail send error:', error);
                                    alert('Error occurred while sending mail.');
                                }
                            };
                            

                            return (
                                <div key={index} className='col-sm-6 col-md-12 col-lg-6'>
                                    <div className='tab-white-block p-4 h-100'>
                                        <span className={`position-absolute test-status ${statusClass}`}>{status}</span>
                                        <div className='row g-2'>
                                            <div className='col-12'>
                                                <span className='font-20 font-500'>{item.test_name}</span>
                                            </div>

                                            <div className='col-4 col-sm-6 col-md-6 col-lg-6'>
                                                {testDateLabel} <span className='d-block font-500'>{testDateValue}</span>
                                            </div>

                                            <div className='col-4 col-sm-6 col-md-6 col-lg-6'>
                                                {testResultLabel} <span className='d-block font-500'>{testResultValue}</span>
                                            </div>

                                            <div className='col-12'>
                                                <div className='row g-2'>
                                                    {showMail && (
                                                        <div className='col-auto'>
                                                            <button className='btn btn-green px-4' onClick={() => handleSendMail(item)}>
                                                                <i className="bi bi-envelope font-18 position-relative me-2"></i>
                                                                <span>Mail</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                    {showCopy && (
                                                        <div className='col-auto'>
                                                            <button className='btn btn-border-gray height-40 px-3' onClick={handleCopy}>
                                                                <i className="bi bi-copy position-relative me-2"></i>
                                                                <span>Copy Link</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                    {showReport && (
                                                        <div className='col-auto'>
                                                            <a
                                                                className='btn btn-green px-3'
                                                                href={profileLink}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                            >
                                                                <i className="bi bi-file-pdf-fill position-relative me-2"></i>
                                                                <span>Report</span>
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}


                        </div>
                            
                    </div>
                    </div>
                </div>
                

                

            </div>
            <DebugBarControl />
        </div>
    );
};

export default Counselling;
